import {
  getAiBotSettingsEndpoints,
  IGetAiBotSettingsDTO,
  IGetAiBotSettingsResponse,
  IUpdateAiBotSettingsDTO,
  IUpdateAiBotSettingsResponse,
} from '@/models/aiBotSettings.model';
import { httpClient, ApiResponse } from '@/utils';

class AiBotConfigAPI {
  static getAiBotSettings({ channelSlug }: IGetAiBotSettingsDTO): ApiResponse<IGetAiBotSettingsResponse> {
    const { GET_AI_BOT_SETTINGS } = getAiBotSettingsEndpoints({ channelSlug });
    return httpClient.get<IGetAiBotSettingsResponse>(GET_AI_BOT_SETTINGS);
  }

  static updateAiBotSettings({
    channelSlug,
    ...data
  }: IUpdateAiBotSettingsDTO): ApiResponse<IUpdateAiBotSettingsResponse> {
    const { UPDATE_AI_BOT_SETTINGS } = getAiBotSettingsEndpoints({ channelSlug });
    return httpClient.patch<IUpdateAiBotSettingsResponse>(UPDATE_AI_BOT_SETTINGS, data);
  }
}

export default AiBotConfigAPI;
